import { URLKeys } from 'noddi-async';
import { useBookingCars, useBookingTimeWindow } from 'noddi-web';

export const useGetConfirmBookingMutationKey = () => {
  const cars = useBookingCars();
  const selectedTimeWindow = useBookingTimeWindow();
  return [URLKeys.postCreateBookingIgnoringImpersonation, cars, selectedTimeWindow];
};
